import api from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadFinancialDataSummary(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    let financialDataSummary = getState().currentOffer.financialDataSummary[key];
    if (financialDataSummary) {
      loading = financialDataSummary.loading;
      loaded = financialDataSummary.loaded;
    }
    if (loading || loaded) return;
    dispatch({ type: actionTypes.LOAD_FINANCIAL_DATA_SUMMARY_STARTED });
    try {
      financialDataSummary = await dispatch(sendHttpRequest(api.getFinancialDataSummary(documentId, siteId)));
      const payload = {
        ...financialDataSummary,
        key: key
      };

      dispatch({ type: actionTypes.LOAD_FINANCIAL_DATA_SUMMARY_SUCCESS, payload: payload, id: key });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FINANCIAL_DATA_SUMMARY_FAILED, payload: { documentId, siteId, error } });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
